module.exports = __webpack_public_path__ + "static/media/service_details.e651b650.jpg";